import config from '@efdigital/ll-xceed-v2/config/environment';
import EmberRouter from '@embroider/router';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('coaching', function () {
    this.route('coach', function () {
      this.route('help', function () {
        this.route('how-coaching-works');
      });
      this.route('settings', function () {
        this.route('availability');
      });
      this.route('sessions', function () {
        this.route('history');
      });
    });
    this.route('coachee', function () {
      this.route('cohort', { path: ':program_id/:cohort_id' }, function () {
        this.route('coaches', function () {
          this.route('coach', { path: ':coach_id' }, function () {
            this.route('book-chemistry');
          });
          this.route('chosen');
          this.route('shortlist');
        });
        this.route('help', function () {
          this.route('how-coaching-works');
          this.route('choosing-a-coach');
          this.route('coaching-handbook');
        });
        this.route('sessions', function () {
          this.route('history');
          this.route('book-session');
        });
        this.route('quiz');
      });
    });
  });
});
